import { useCallback } from 'react'
import { generatePath, useLocation, useNavigate } from 'react-router-dom'
import { ROUTES } from '../constants/routes'
import { requestOpenMessagesChannel } from '../redux/atlasai/actions'
import { useDispatch } from '../redux/hooks'

/**
 * Opens a conversation from a floating pill: in the AIM panel over the current page when
 * `canUseBubble` and you're off Messages, otherwise on the Messages page.
 */
const useOpenConversation = (canUseBubble: boolean): ((channelId: string) => void) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { pathname } = useLocation()

  return useCallback(
    (channelId: string) => {
      if (canUseBubble && !pathname.startsWith(ROUTES.MESSAGES)) {
        dispatch(requestOpenMessagesChannel(channelId))
        return
      }
      void navigate(generatePath(ROUTES.MESSAGES_CHANNEL, { channelId }))
    },
    [canUseBubble, dispatch, navigate, pathname],
  )
}

export default useOpenConversation
